import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormFieldValue } from '../dynamic-test/dynamic-test.types';
import { FieldClick, FormFieldConfig, FormFieldOption, FormFieldType } from './form-field.types';

interface FieldStyle {
	position: string;
	top: string;
	left: string;
	width: string;
	height: string;
}

@Component({
	selector: 'maj-form-field',
	imports: [CommonModule, FormsModule],
	styles: [
		'.selected, .selected input, .selected select, .selected textarea {background-color: lightblue}',
	],
	templateUrl: './form-field.component.html',
})
export class FormFieldComponent {
	FormFieldType = FormFieldType;

	@Input()
	config!: FormFieldConfig;

	@Input()
	isSelected = false;

	@Input()
	value: FormFieldValue = null;

	@Output()
	valueChange = new EventEmitter<FormFieldValue>();

	@Output()
	fieldSelected = new EventEmitter<FieldClick<FormFieldValue>>();

	onFieldClick($event: MouseEvent) {
		this.fieldSelected.emit({$event, id: this.config.id, value: this.value});
	}

	onModelChange(newValue: FormFieldValue) {
		this.value = newValue;
		this.valueChange.emit(this.value);
	}

	get fieldStyle(): FieldStyle {
		return {
			position: 'absolute',
			top: `${this.config?.top ?? 0}px`,
			left: `${this.config?.left ?? 0}px`,
			width: `${this.config?.width ?? 0}px`,
			height: `${this.config?.height ?? 0}px`,
		};
	}

	get sortedOptions() {
		const options = this.config?.options ?? [];

		return options.slice().sort((a: FormFieldOption, b: FormFieldOption) => {
			const aOptionOrder = Number(a.displayOrder);
			const bOptionOrder = Number(b.displayOrder);
			return aOptionOrder - bOptionOrder;
		});
	}
}
